import { useMemo } from 'react';
import { useCompany } from '@/contexts/CompanyContext';

interface CompanyProductType {
  isDimensions: boolean;
  isFinancials: boolean;
  hasLinkedProduct: boolean;
  linkedProductName: string | undefined;
}

export function useCompanyProductType(): CompanyProductType {
  const { selectedCompany } = useCompany();

  return useMemo(() => {
    const linkedProductName = selectedCompany?.linkedProductName;
    const lower = linkedProductName?.toLowerCase() ?? '';
    const isDimensions = lower.includes('dimensions');
    const isFinancials = lower.includes('financials');

    return {
      isDimensions,
      isFinancials,
      hasLinkedProduct: isDimensions || isFinancials,
      linkedProductName,
    };
  }, [selectedCompany?.linkedProductName]);
}
